import { Interpolation, Theme, css } from '@emotion/react'

export const divider: Interpolation<Theme> = (theme) => css`
  margin: ${theme.spacing(3)} 0;
  border-color: ${theme.backgrounds.backgroundOne};
`
